import { createInterfaceId } from "@gitlab/needle";
//#region src/duo_feature_access_service.ts
const DuoFeatureAccessService = createInterfaceId("DuoFeatureAccessService");
//#endregion
//#region src/duo_feature.ts
let DuoFeature = /* @__PURE__ */ function(DuoFeature) {
	DuoFeature["IncludeFileContext"] = "include_file_context";
	DuoFeature["IncludeSnippetContext"] = "include_snippet_context";
	DuoFeature["IncludeMergeRequestContext"] = "include_merge_request_context";
	DuoFeature["IncludeIssueContext"] = "include_issue_context";
	DuoFeature["IncludeDependencyContext"] = "include_dependency_context";
	DuoFeature["IncludeLocalGitContext"] = "include_local_git_context";
	DuoFeature["IncludeTerminalContext"] = "include_terminal_context";
	DuoFeature["IncludeRepositoryContext"] = "include_repository_context";
	DuoFeature["IncludeUserRule"] = "include_user_rule_context";
	return DuoFeature;
}({});
//#endregion
//#region src/duo_code_suggestions_context.ts
let DuoCodeSuggestionsContext = /* @__PURE__ */ function(DuoCodeSuggestionsContext) {
	DuoCodeSuggestionsContext["OpenTabs"] = "open_tabs";
	DuoCodeSuggestionsContext["Imports"] = "imports";
	return DuoCodeSuggestionsContext;
}({});
//#endregion
export { DuoCodeSuggestionsContext, DuoFeature, DuoFeatureAccessService };

//# sourceMappingURL=index.mjs.map